import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SchedulePage from "./pages/SchedulePage";
import PricingPage from "./pages/PricingPage";
import GalleryPage from "./pages/GalleryPage";
import InstructorsPage from "./pages/InstructorsPage";
import ContactPage from "./pages/ContactPage";
import { Toaster } from "./components/ui/sonner";
import StructuredData from "./components/StructuredData";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StructuredData />
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/schedule" element={<SchedulePage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/instructors" element={<InstructorsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;